import React from 'react';
import { Button, Form, Input, Divider, message } from 'antd';
import {
  MailOutlined,
  LockOutlined,
  GoogleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store/store';
import { loginUser } from '../../../redux/actions/auth/login/Login';

interface LoginResult {
  error?: boolean;
  message?: string;
  respuesta: boolean;
}

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { loading, error } = useSelector((state: RootState) => state.login || { loading: false, error: null });

  const onFinish = async (values: any) => {
    try {
      const loginData = {
        email: values.email,
        contrasena: values.password
      };

      const result: LoginResult = await dispatch(loginUser(loginData) as any);

      console.log(result);

      if (result && result.respuesta && !result.error) {
        message.success('Inicio de sesión exitoso');
        navigate('/home');
      } else {
        message.error(result?.message || 'Error al iniciar sesión');
      }
    } catch (err) {
      console.error('Error durante el inicio de sesión:', err);
      message.error('Ocurrió un error inesperado');
    }
  };

  return (
    <div>
      <div className="min-h-screen flex flex-col md:flex-row">
        <div className="w-full md:w-1/2 flex items-center justify-center p-4">
          <div className="max-w-md w-full">
            <div className="flex justify-center items-center mb-8">
              <div className="text-primary flex items-center">
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-8">
              <h2 className="text-2xl font-bold text-center mb-2">Iniciar Sesión</h2>
              <p className="text-gray-500 text-center mb-6">Plataforma para clínicas.</p>

              {error && (
                <div className="mb-4 p-3 bg-red-50 text-red-500 rounded">
                  {error}
                </div>
              )}

              <Form
                form={form}
                name="login"
                onFinish={onFinish}
                layout="vertical"
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: 'Ingresa un email!' },
                    { type: 'email', message: 'Ingresa un email válido!' }
                  ]}
                >
                  <Input
                    prefix={<MailOutlined className="text-gray-400" />}
                    placeholder="xyz@example.com"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  label="Contraseña"
                  rules={[{ required: true, message: 'Ingresa tu contraseña!' }]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="text-gray-400" />}
                    placeholder="xxxx"
                  />
                </Form.Item>

                <div className="flex justify-between items-center mb-6">
                  <a href="/forgot-password" className="text-primary">¿Olvidaste tu contraseña?</a>
                </div>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Iniciar Sesión
                  </Button>
                </Form.Item>
              </Form>

              <Divider plain>o inicia con otros métodos</Divider>
              <div className="flex justify-center space-x-4 mb-6">
                <Button shape="circle" icon={<GoogleOutlined />} />
              </div>
              <p className="text-center text-gray-600">
                ¿Todavía no tienes cuenta?{' '}
                <a href="/sign-up" className="text-primary">Click aquí para registrarte.</a>
              </p>
            </div>
          </div>
        </div>
        <div className="hidden md:block md:w-1/2 bg-primary overflow-hidden">
          <div className="h-full w-full bg-gradient-to-br from-primary to-blue-600 flex items-center justify-center">
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;